import { URL_ROUTES } from '@/constants';

import type { IErrorHandlerBilling } from './error-handler.interfaces';

export enum ECta {
  ENTIENDO = 'Entendido',
  SELECCIONA = 'Seleccionar otro medio de pago',
  REINTENTAR = 'Volver a intentar',
  REINTENTAR_GC = 'Reintentar',
  MODIFICAR_PEDIDO = 'Modificar pedido',
  IR_A_DATOS = 'Ir a Datos',
  IR_A_ENTREGA = 'Ir a Entrega',
  IR_AL_WSP_PARIS = 'Ir al WhatsApp Paris'
}

export enum Type {
  INFO = 'info',
  REDIRECT = 'redirect'
}

export enum ErrorTypeBilling {
  PAYMENT = 'PaymentIntentError',
  SHIPPING = 'CartIncompleteShippingAddress',
  DELIVERY = 'NoDeliveryInfo',
  DEMAND = 'DemandError',
  DEFAULT = 'Default',
  GIFTCARD = 'PaymentValidateGiftCardError',
  CART_IS_EMPTY = 'CartIsEmpty'
}

// asssets
export const contentAssestPaymentsGiftcard = 'BillingGiftCardError'; // 1
export const contentAssestPaymentsPay = 'BillingInvalidCardIcon'; //2
export const contentAssestPaymentsDog = 'BillingConnectionErrorIcon'; //3
export const contentAssestPaymentsPayLimit = 'BillingExceedsMaxAmount'; //4
export const contentAssestPaymentsPayErrorCard = 'BillingInvalidExpirationDate'; //5
export const contentAssestPaymentsDefault = 'BillingGeneralError'; //6
export const contentAssestPaymentsPayCardBlocked = 'BillingCardBlocked'; //7
export const contentAssestPaymentsPayCardExpired = 'BillingCardExpired'; //8

// titles
export const errorTitleCancelastePagoCencopay =
  'Cancelaste el pago con CencoPay';
export const errorTitleErrorConexion = 'Error de conexión';
export const errorTitleProductoAgtado = 'Este producto está agotado';
export const errorTitleProductosNoPagoGiftCard =
  'Estos productos no pueden pagarse con tu Gift Card';
export const errorTitleExidisteMonto = 'Excediste el monto diario permitido';
export const errorTitleExidisteMontoMaximo = 'Excediste el monto máximo';
export const errorTitleClaveIncorrecta =
  'La clave que ingresaste es incorrecta';
export const errorTitleGiftCardNoExiste = 'La Gift Card no existe';
export const errorTitleTarjetaInvalida = 'La tarjeta ingresada es inválida';
export const errorTitleNoAgregarGiftCard = 'No pudimos agregar tu Gift Card';
export const errorTitleNoPudimosProcesarPago = 'No pudimos procesar tu pago';
export const errorTitleOcurrioErrorConexion = 'Ocurrió un error de conexión';
export const errorTitleRevisaDatosIngresados = 'Revisa los datos ingresados';
export const errorTitleRutIncorrecto = 'RUT incorrecto';
export const errorTitleStockInsuficiente = 'Stock insuficiente';
export const errorTitleSuperasteLimite = 'Superaste el límite de intentos';
export const errorTitleGiftCardBloqueada = 'Tu Gift Card está bloqueada';
export const errorTitleGiftCardInactiva = 'Tu Gift Card está inactiva';
export const errorTitleGiftCardExpiro = 'Tu Gift Card expiró';
export const errorTitleGiftCardEliminada = 'Tu Gift Card fue eliminada';
export const errorTitleGiftCardNoValida =
  'Tu Gift Card no es válida en esta tienda';
export const errorTitleGiftCardSinSaldo = 'Tu Gift Card no tiene saldo';
export const errorTitleTarjetaBloqueada = 'Tu tarjeta está bloqueada';
export const errorTitleTarjetaExpiro = 'Tu tarjeta expiró';
export const errorTitleProblemasGiftCard =
  'Tuvimos un problema con tu Gift Card';
export const errorTitleIngresaGiftcardNuevamente =
  'Ingresa nuevamente tu Gift Card';
export const errorTitleErrorDePago = 'Error de pago';
export const errorTitleEntrega = 'No podremos entregar tu compra hoy';
export const errorTitleLimiteCompras = 'Superaste el límite de compras';
export const errorTitleCuponExpirado = 'Tu cupón ha expirado';

// messages
export const errorMessage01 =
  '¡Lo sentimos! Esta Gift Card no existe. Si necesitas ayuda, escríbenos a giftcard@cencosud.cl';
export const errorMessage02 =
  '¡Lo sentimos! Este producto ya no está disponible. Estamos trabajando para reponerlo pronto.';
export const errorMessage03 =
  '¡Lo sentimos! Hubo un problema y no pudimos concretar tu compra por lo que no hicimos ningún cargo. Por favor, vuelve a intentar.';
export const errorMessage04 =
  '¡Lo sentimos! Hubo un problema y no pudimos confirmar la compra por lo que no hicimos ningún cargo. Por favor, comunícate con tu banco o utiliza otro medio de pago.';
export const errorMessage05 =
  '¡Lo sentimos! Hubo un problema y no pudimos confirmar tu pago por lo que no hicimos ningú cargo. Por favor, revisa los datos y vuelve a intentar o prueba con otro medio de pago.';
export const errorMessage06 =
  '¡Lo sentimos! Hubo un problema y no pudimos confirmar tu pago por lo que no hicimos ningún cargo. Por favor, revisa los datos y vuelve a intentar o prueba con otro medio de pago.';
export const errorMessage07 =
  '¡Lo sentimos! Hubo un problema y no pudimos procesar el pago por lo que no hicimos ningún cargo. Por favor, intenta con otro medio de pago.';
export const errorMessage08 =
  '¡Lo sentimos! No es posible agregar esta Gift Card. Si necesitas ayuda, escríbenos a giftcard@cencosud.cl';
export const errorMessage09 =
  '¡Lo sentimos! No es posible pagar con esta Gift Card. Si necesitas ayuda, escríbenos a giftcard@cencosud.cl';
export const errorMessage10 =
  '¡Lo sentimos! No pudimos autorizar tu pago porque supera el límite de seguridad de intentos de compra establecido por tu banco. Por favor, comunícate con tu banco o utiliza otro medio de pago. No hicimos ningún cargo.';
export const errorMessage11 =
  '¡Lo sentimos! No pudimos autorizar tu pago porque supera el límite de seguridad diario establecido por tu banco. Por favor, vuelve a intentar mañana o elige otro medio de pago. No hicimos ningún cargo.';
export const errorMessage12 =
  '¡Lo sentimos! No pudimos confirmar tu pago por lo que no hicimos ningún cargo en tu tarjeta. Por favor, contacta a tu banco o intenta con otro medio de pago.';
export const errorMessage13 =
  '¡Lo sentimos! No pudimos confirmar tu pago por lo que no hicimos ningún cargo.  Por favor, contacta a tu banco o intenta con otro medio de pago.';
export const errorMessage14 =
  '¡Lo sentimos! No pudimos confirmar tu pago por lo que no hicimos ningún cargo. Revisa los datos de tu tarjeta y vuelve a intentar o utiliza otro medio de pago.';
export const errorMessage15 =
  '¡Lo sentimos! No pudimos procesar tu pago por lo que no hicimos ningún cargo. Comprueba la conexión y vuelve a intentar o utiliza otro medio de pago.';
export const errorMessage16 =
  '¡Lo sentimos! Tu Gift Card no puede ser utilizada en esta tienda. Si necesitas ayuda, escríbenos a giftcard@cencosud.cl';
export const errorMessage17 =
  '¡Lo sentimos! Tuvimos problemas para confirmar el pago por lo que no hicimos ningún cargo. Comunícate con tu banco o elige otro medio de pago para continuar.';
export const errorMessage18 =
  '¡Lo sentimos! Ya no es posible utilizar esta Gift Card. Si necesitas ayuda, escríbenos a giftcard@cencosud.cl';
export const errorMessage19 =
  'Completa tu compra combinado tu Gift Card con otro medio de pago o elimínalos para continuar. ';
export const errorMessage20 =
  'El monto disponible que tiene tu Gift Card requiere que la nomines con el RUT de la cuenta de acceso a este sitio. Descarga la App Mi Gift Card Cencosud y podrás hacerlo tú mismo, de lo contrario solicítalo a giftcard@cencosud.cl';
export const errorMessage21 =
  'El RUT que ingresaste no está asociado a esta Gift Card. Si necesitas ayuda, escríbenos a empresas@cencosud.cl';
export const errorMessage22 =
  'El saldo de tu Gift Card requiere que la asocies a tu RUT para utilizarla en este sitio. Por favor, envía un correo a giftcard@cencosud.cl para hacer la gestión.';
export const errorMessage23 =
  'La cantidad agregada del producto no está disponible en este momento. Por favor, ajusta la cantidad o verifica más tarde.';
export const errorMessage24 =
  'Lo sentimos, no pudimos conectarte con CencoPay. Por favor, intenta de nuevo o prueba con otro medio de pago. No hicimos ningún cargo.';
export const errorMessage25 =
  'Lo sentimos, no pudimos confirmar tu pago. Por favor, contacta a tu banco o intenta con otro medio de pago. No hicimos ningún cargo.';
export const errorMessage26 =
  'No es posible concretar la compra. Por favor, vuelve a intentar o escoge otro medio de pago.';
export const errorMessage27 =
  'No pudimos confirmar tu pago debido a que uno o más datos de tu tarjeta fueron ingresados incorrectamente. Por favor, vuelve a intentar o utiliza otro medio de pago. No hicimos ningún cargo.';
export const errorMessage28 = 'Ocurrió un error de conexión';
export const errorMessage29 =
  'Por favor, elige otro medio de pago para continuar.';
export const errorMessage30 = 'Por favor, intenta con otro medio de pago.';
export const errorMessage31 =
  'Por favor, revisa los datos ingresados. Asegúrate de haber completado los campos solicitados y vuelve a intentar o selecciona otro medio de pago.';
export const errorMessage32 =
  'Por favor, revísala y vuelve a intentar. Si necesitas ayuda, escríbenos a giftcard@cencosud.cl';
export const errorMessage33 =
  'Lo sentimos, no pudimos confirmar tu pago debido a un error con tu RUT o correo. Por favor, dirígete al WhatsApp de Paris para actualizar tu información. No se realizó ningún cargo.';
export const errorMessage34 =
  'Lo sentimos, no pudimos procesar tu pago debido a un error con tu RUT o correo. Por favor, vuelve al paso Datos para revisar y actualizar tu información. No hicimos ningún cargo.';
export const errorMessage35 =
  'Lo sentimos, no pudimos procesar tu pago debido a un error con tu dirección. Por favor, vuelve al paso Entrega para revisarla y actualizarla. No hicimos ningún cargo.';
export const errorMessage36 =
  'Lo sentimos, no pudimos procesar tu pago debido a un error con tu RUT. Dirígete a Mi cuenta > Datos personales para actualizar tu información. No hicimos ningún cargo.';
export const errorMessage37 =
  'Lo sentimos, no pudimos procesar tu pago por un error en la información. No hicimos ningún cargo.';
export const errorMessage38 =
  'Lo sentimos, no pudimos confirmar tu pago debido a un error con tus datos (nombre, apellido o teléfono). Por favor, dirígete a Mi cuenta > Datos personales para actualizar tu información. No se realizó ningún cargo.';
export const errorMessage39 =
  'Lo sentimos, no pudimos procesar tu pago debido a un error con tus datos (nombre, apellido o teléfono). Por favor, vuelve al paso Datos para revisar y actualizar tu información. No hicimos ningún cargo.';
export const errorMessage40 =
  '¡Lo sentimos! Los productos de tu carro están agotados. Puedes eliminarlos o guardarlos para después.';
export const errorMessage41 =
  '¡Lo sentimos! Realizaste tu compra posterior a nuestro cierre de entregas para hoy. Te mostraremos la fecha disponible más cercana.';
export const errorMessage42 =
  '¡Lo sentimos! Tu pago supera el límite de tu tarjeta. Intenta con otro medio de pago. No hemos hecho ningún cobro.';
export const errorMessage43 =
  '¡Lo sentimos! No pudimos autorizar tu pago porque supera el límite de seguridad de intentos de compra establecido por tu banco. Por favor, intenta pagar a través de Webpay.';
export const errorMessage44 =
  '¡Lo sentimos! No pudimos autorizar tu pago porque supera el límite de seguridad de tu banco. Intenta pagar con otro medio de pago.';
export const errorMessage45 =
  'Completa tu compra combinado tu Gift Card con otro medio de pago o elimínalos para continuar.';
export const errorMessage46 =
  'Al aplicar el cupón, tu total a pagar cambió. Ingresa nuevamente tu Gift Card para aplicar el descuento correctamente.No hicimos ningún cargo.';
export const errorMessage47 =
  'Lo sentimos, tu cupón ha expirado y lo eliminamos de tu compra. Por favor, intenta pagar nuevamente.';

// errors codes backend
const REJECTED = 'REJECTED';
const CANCELLED = 'CANCELLED';
const errorCodeCHKDM0001 = 'CHKDM0001';
const errorCodeCHKDM0002 = 'CHKDM0002';
const errorCodeCHKDM0003 = 'CHKDM0003';
const errorCodeCHKDM0004 = 'CHKDM0004';
const errorCodeCHKDM0005 = 'CHKDM0005';
const errorCodeCHKDM0006 = 'CHKDM0006';
const errorCodeCHKDM0007 = 'CHKDM0007';
const errorCodeCHKPY260010 = 'CHKPY260010';
const errorCodeCHKPY210009 = 'CHKPY210009';
const errorCodeCHKPY210010 = 'CHKPY210010';
const errorCodeCHKPY260006 = 'CHKPY260006';
const errorCodeCHKPY260009 = 'CHKPY260009';
const errorCodeCHKPY210006 = 'CHKPY210006';
const errorCodeCHKSPD000 = 'CHKSPD000';
const errorCodeCHKSPD001 = 'CHKSPD001';
const errorCodeCHKSPD002 = 'CHKSPD002';
const errorCodeCHKSPD003 = 'CHKSPD003';
const errorCodeCHKSPD004 = 'CHKSPD004';
const errorCodeCHKSPD005 = 'CHKSPD005';
const errorCodeCHKSPD006 = 'CHKSPD006';
const errorCodeCHKSPD007 = 'CHKSPD007';
const errorCodeCHKSPD008 = 'CHKSPD008';
const errorCodeCHKSPD009 = 'CHKSPD009';
const errorCodeCHKPY60091 = 'CHKPY60091';
const errorCodeCHKPY60095 = 'CHKPY60095';
const errorCodeCHKPY260098 = 'CHKPY260098';
const errorCodeCHKPY260099 = 'CHKPY260099';
const errorCodeCHKPY60096 = 'CHKPY60096';
const errorCodeCHKPY60099 = 'CHKPY60099';
const errorCodeCHKPY260500 = 'CHKPY260500';
const errorCodeCHKPY210095 = 'CHKPY210095';
const errorCodeCHKPY210096 = 'CHKPY210096';
const errorCodeCHKPY210097 = 'CHKPY210097';
const errorCodeCHKPY210098 = 'CHKPY210098';
const errorCodeCHKPY210099 = 'CHKPY210099';
const errorCodeCHKPY210500 = 'CHKPY210500';
const errorCodeCHKPY60094 = 'CHKPY60094';
const errorCodeCHKPY260100 = 'CHKPY260100';
const errorCodeCHKPY30101 = 'CHKPY30101';
const errorCodeCHKPY30102 = 'CHKPY30102';
const errorCodeCHKPY30104 = 'CHKPY30104';
const errorCodeCHKPY30110 = 'CHKPY30110';
const errorCodeCHKPY30150 = 'CHKPY30150';
const errorCodeCHKPY30151 = 'CHKPY30151';
const errorCodeCHKPY30152 = 'CHKPY30152';
const errorCodeCHKPY30154 = 'CHKPY30154';
const errorCodeCHKPY301200 = 'CHKPY301200';
const errorCodeCHKPY30201 = 'CHKPY30201';
const errorCodeCHKPY30202 = 'CHKPY30202';
const errorCodeCHKPY30203 = 'CHKPY30203';
const errorCodeCHKPY30204 = 'CHKPY30204';
const errorCodeCHKPY30205 = 'CHKPY30205';
const errorCodeCHKPY301207 = 'CHKPY301207';
const errorCodeCHKPY30209 = 'CHKPY30209';
const errorCodeCHKPY30208 = 'CHKPY30208';
const errorCodeCHKPY30210 = 'CHKPY30210';
const errorCodeCHKPY30211 = 'CHKPY30211';
const errorCodeCHKPY30220 = 'CHKPY30220';
const errorCodeCHKPY30221 = 'CHKPY30221';
const errorCodeCHKPY30222 = 'CHKPY30222';
const errorCodeCHKPY30230 = 'CHKPY30230';
const errorCodeCHKPY30231 = 'CHKPY30231';
const errorCodeCHKPY30232 = 'CHKPY30232';
const errorCodeCHKPY30233 = 'CHKPY30233';
const errorCodeCHKPY30234 = 'CHKPY30234';
const errorCodeCHKPY30235 = 'CHKPY30235';
const errorCodeCHKPY30236 = 'CHKPY30236';
const errorCodeCHKPY30237 = 'CHKPY30237';
const errorCodeCHKPY30238 = 'CHKPY30238';
const errorCodeCHKPY30239 = 'CHKPY30239';
const errorCodeCHKPY30240 = 'CHKPY30240';
const errorCodeCHKPY30241 = 'CHKPY30241';
const errorCodeCHKPY30242 = 'CHKPY30242';
const errorCodeCHKPY30243 = 'CHKPY30243';
const errorCodeCHKPY30246 = 'CHKPY30246';
const errorCodeCHKPY30247 = 'CHKPY30247';
const errorCodeCHKPY30248 = 'CHKPY30248';
const errorCodeCHKPY30250 = 'CHKPY30250';
const errorCodeCHKPY30251 = 'CHKPY30251';
const errorCodeCHKPY30254 = 'CHKPY30254';
const errorCodeCHKPY30268 = 'CHKPY30268';
const errorCodeCHKPY30400 = 'CHKPY30400';
const errorCodeCHKPY30450 = 'CHKPY30450';
const errorCodeCHKPY30451 = 'CHKPY30451';
const errorCodeCHKPY30452 = 'CHKPY30452';
const errorCodeCHKPY30453 = 'CHKPY30453';
const errorCodeCHKPY30454 = 'CHKPY30454';
const errorCodeCHKPY30455 = 'CHKPY30455';
const errorCodeCHKPY30456 = 'CHKPY30456';
const errorCodeCHKPY30457 = 'CHKPY30457';
const errorCodeCHKPY30458 = 'CHKPY30458';
const errorCodeCHKPY30459 = 'CHKPY30459';
const errorCodeCHKPY30460 = 'CHKPY30460';
const errorCodeCHKPY30461 = 'CHKPY30461';
const errorCodeCHKPY30475 = 'CHKPY30475';
const errorCodeCHKPY30476 = 'CHKPY30476';
const errorCodeCHKPY30478 = 'CHKPY30478';
const errorCodeCHKPY30480 = 'CHKPY30480';
const errorCodeCHKPY30481 = 'CHKPY30481';
const errorCodeCHKPY30490 = 'CHKPY30490';
const errorCodeCHKPY30491 = 'CHKPY30491';
const errorCodeCHKPY30520 = 'CHKPY30520';
const errorCodeCHKPY30700 = 'CHKPY30700';
const errorCodeCHKPY30701 = 'CHKPY30701';
const errorCodeCHKPY30702 = 'CHKPY30702';
const errorCodeCHKPY30703 = 'CHKPY30703';
const errorCodeCHKPY60092 = 'CHKPY60092';
const errorCodeCHKPY60093 = 'CHKPY60093';
const errorCodeCHKPY2E003 = 'CHKPY2E003';
const errorCodeCHKPY2E012 = 'CHKPY2E012';
const errorCodeCHKPY2E005 = 'CHKPY2E005';
const errorCodeCHKPY2E006 = 'CHKPY2E006';
const errorCodeCHKPY210011 = 'CHKPY210011';
const errorCodeCHKPY260011 = 'CHKPY260011';
const errorCodeCHKPY260003 = 'CHKPY260003';
const errorCodeCHKPY210003 = 'CHKPY210003';
const errorCodeCHKPY260008 = 'CHKPY260008';
const errorCodeCHKPY210008 = 'CHKPY210008';
const errorCodeCHKPY260007 = 'CHKPY260007';
const errorCodeCHKPY260001 = 'CHKPY260001';
const errorCodeCHKPY210001 = 'CHKPY210001';
const errorCodeCHKPY260002 = 'CHKPY260002';
const errorCodeCHKPY210002 = 'CHKPY210002';
const errorCodeCHKPY2E016 = 'CHKPY2E016';
const errorCodeCHKPYCP002 = 'CHKPYCP002';
const errorCodeCHKPY2E013 = 'CHKPY2E013';
const errorCodeCHKPY2E017 = 'CHKPY2E017';
const errorCodeCHKPY2E030 = 'CHKPY2E030';
const errorCodeCHKPY2E027 = 'CHKPY2E027';
const errorCodeCHKPY2E031 = 'CHKPY2E031';
const errorCodeCHKPYCP003 = 'CHKPYCP003';
const errorCodeCHKPY210007 = 'CHKPY210007';
const errorCodeCHKPY2E007 = 'CHKPY2E007';
const errorCodeCHKPY2E009 = 'CHKPY2E009';
const errorCodeCHKPY2E018 = 'CHKPY2E018';
const errorCodeCHKPY2E019 = 'CHKPY2E019';
const errorCodeCHKPY2E020 = 'CHKPY2E020';
const errorCodeCHKPY2E021 = 'CHKPY2E021';
const errorCodeCHKPY2E022 = 'CHKPY2E022';
const errorCodeCHKPY2E9998 = 'CHKPY2E9998';
const errorCodeCHKPY2E9999 = 'CHKPY2E9999';
const errorCodeCHKPY2E500 = 'CHKPY2E500';
const errorCodeCHKPY2E000 = 'CHKPY2E000';
const errorCodeCHKPY2E002 = 'CHKPY2E002';
const errorCodeCHKPY2E004 = 'CHKPY2E004';
const errorCodeCHKPY2E015 = 'CHKPY2E015';
const errorCodeCHKPY2E023 = 'CHKPY2E023';
const errorCodeCHKPY2E024 = 'CHKPY2E024';
const errorCodeCHKPY2E025 = 'CHKPY2E025';
const errorCodeCHKPY2E026 = 'CHKPY2E026';
const errorCodeCHKPY2E028 = 'CHKPY2E028';
const errorCodeCHKPY2E029 = 'CHKPY2E029';
const errorCodeCHKPY260004 = 'CHKPY260004';
const errorCodeCHKPY260005 = 'CHKPY260005';
const errorCodeCHKPY210004 = 'CHKPY210004';
const errorCodeCHKPY210005 = 'CHKPY210005';
const errorCodeCHKPY2E001 = 'CHKPY2E001';
const errorCodeCHKPY2E008 = 'CHKPY2E008';
const errorCodeCHKPY2E010 = 'CHKPY2E010';
const errorCodeCHKPY2E014 = 'CHKPY2E014';
const errorCodeCHKPYCP001 = 'CHKPYCP001';
export const errorCodeCHKPY60000 = 'CHKPY60000';
export const errorCodeCHKPY10000 = 'CHKPY10000';
export const errorCodeCHKPY30100 = 'CHKPY30100';
export const errorCodeCHKPY2I000 = 'CHKPY2I000';
const errorCodeCHKPY2E011 = 'CHKPY2E011';
const errorCodeCHKPY2E433 = 'CHKPY2E433';
const errorCodeCHKRECST001 = 'CHKRECST001';
const errorCodeCHKRECST002 = 'CHKRECST002';
const errorCodeCHKRECST005 = 'CHKRECST005';
const errorCodeCHKRECST003 = 'CHKRECST003';
const errorCodeCHKRERUT001 = 'CHKRERUT001';
const errorCodeCHKRECST004 = 'CHKRECST004';
const errorCodeCHKREADR001 = 'CHKREADR001';
const errorCodeCHKREADR002 = 'CHKREADR002';
const errorCodeCHKREADR003 = 'CHKREADR003';
const errorCodeCHKREAMT001 = 'CHKREAMT001';
const errorCodeCHKGSCST001 = 'CHKGSCST001';
const errorCodeCHKGSCST002 = 'CHKGSCST002';
const errorCodeCHKGSCST005 = 'CHKGSCST005';
const errorCodeCHKGSCST003 = 'CHKGSCST003';
const errorCodeCHKGSRUT001 = 'CHKGSRUT001';
const errorCodeCHKGSCST004 = 'CHKGSCST004';
const errorCodeCHKGSADR001 = 'CHKGSADR001';
const errorCodeCHKGSADR002 = 'CHKGSADR002';
const errorCodeCHKGSADR003 = 'CHKGSADR003';
const errorCodeCHKGSAMT001 = 'CHKGSAMT001';
const errorCodeCHKPY210090 = 'CHKPY210090';

// errors codes frontend
const errorCodeCHKFE0001 = 'CHKFE0001';
const errorCodeCHKFE0002 = 'CHKFE0002';
const errorCodeCHKFE0003 = 'CHKFE0003';
const errorCodeCHKFE0004 = 'CHKFE0004';
const errorCodeCHKFE0005 = 'CHKFE0005';
const errorCodeCHKFE0006 = 'CHKFE0006';
const errorCodeCHKFE0007 = 'CHKFE0007';

export const errorCodeCHKCOUPON001 = 'CHKCOUPON001';

// defaults error handlers
export const errorDefault: IErrorHandlerBilling = {
  contentAssets: contentAssestPaymentsDefault,
  title: errorTitleOcurrioErrorConexion,
  message: errorMessage15,
  cta: ECta.ENTIENDO,
  type: Type.INFO,
  errorCode: errorCodeCHKFE0001,
  originError: ErrorTypeBilling.DEFAULT
};
export const errorDefaultPayment: IErrorHandlerBilling = {
  contentAssets: contentAssestPaymentsPay,
  title: errorTitleNoPudimosProcesarPago,
  message: errorMessage06,
  cta: ECta.ENTIENDO,
  type: Type.INFO,
  errorCode: errorCodeCHKFE0002,
  originError: ErrorTypeBilling.PAYMENT
};
export const errorDefaultGiftCard: IErrorHandlerBilling = {
  contentAssets: contentAssestPaymentsGiftcard,
  title: errorTitleNoPudimosProcesarPago,
  message: errorMessage03,
  cta: ECta.ENTIENDO,
  type: Type.INFO,
  errorCode: errorCodeCHKFE0006,
  originError: ErrorTypeBilling.PAYMENT
};
export const errorDefaultShipping: IErrorHandlerBilling = {
  contentAssets: contentAssestPaymentsDefault,
  title: errorTitleNoPudimosProcesarPago,
  message: errorMessage06,
  cta: ECta.ENTIENDO,
  type: Type.INFO,
  errorCode: errorCodeCHKFE0003,
  originError: ErrorTypeBilling.SHIPPING
};
export const errorDefaultDelivery: IErrorHandlerBilling = {
  contentAssets: contentAssestPaymentsDefault,
  title: errorTitleNoPudimosProcesarPago,
  message: errorMessage06,
  cta: ECta.ENTIENDO,
  type: Type.INFO,
  errorCode: errorCodeCHKFE0004,
  originError: ErrorTypeBilling.DELIVERY
};
export const errorDefaultDemand: IErrorHandlerBilling = {
  contentAssets: contentAssestPaymentsDefault,
  title: errorTitleNoPudimosProcesarPago,
  message: errorMessage06,
  type: Type.REDIRECT,
  cta: ECta.ENTIENDO,
  redirectUrl: URL_ROUTES.SHIPPING,
  errorCode: errorCodeCHKFE0005,
  originError: ErrorTypeBilling.DEMAND
};
export const errorDefaultCartEmpty: IErrorHandlerBilling = {
  contentAssets: contentAssestPaymentsDefault,
  title: errorTitleNoPudimosProcesarPago,
  message: errorMessage03,
  type: Type.REDIRECT,
  cta: ECta.ENTIENDO,
  redirectUrl: URL_ROUTES.HOME,
  errorCode: errorCodeCHKFE0007,
  originError: ErrorTypeBilling.CART_IS_EMPTY
};

// error handlers backend
export const errorBillingArray: IErrorHandlerBilling[] = [
  //Cencopay errors
  {
    contentAssets: contentAssestPaymentsGiftcard,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage17,
    cta: ECta.ENTIENDO,
    type: Type.INFO,
    errorCode: errorCodeCHKPYCP002,
    originError: REJECTED
  },
  {
    contentAssets: contentAssestPaymentsGiftcard,
    title: errorTitleCancelastePagoCencopay,
    message: errorMessage29,
    cta: ECta.SELECCIONA,
    type: Type.INFO,
    errorCode: errorCodeCHKPYCP001,
    originError: CANCELLED
  },
  {
    contentAssets: contentAssestPaymentsDog,
    title: errorTitleErrorConexion,
    message: errorMessage24,
    cta: ECta.ENTIENDO,
    type: Type.INFO,
    errorCode: errorCodeCHKPYCP003,
    originError: errorCodeCHKPYCP003
  },
  //Giftcard errors
  {
    title: errorTitleGiftCardNoExiste,
    message: errorMessage01,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E011,
    originError: errorCodeCHKPY2E011
  },
  {
    title: errorTitleGiftCardBloqueada,
    message: errorMessage08,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E003,
    originError: errorCodeCHKPY2E003
  },
  {
    title: errorTitleGiftCardBloqueada,
    message: errorMessage08,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E012,
    originError: errorCodeCHKPY2E012
  },
  {
    title: errorTitleGiftCardInactiva,
    message: errorMessage08,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E005,
    originError: errorCodeCHKPY2E005
  },
  {
    title: errorTitleGiftCardEliminada,
    message: errorMessage08,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E006,
    originError: errorCodeCHKPY2E006
  },
  {
    title: errorTitleGiftCardExpiro,
    message: errorMessage08,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E013,
    originError: errorCodeCHKPY2E013
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E007,
    originError: errorCodeCHKPY2E007
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E009,
    originError: errorCodeCHKPY2E009
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E018,
    originError: errorCodeCHKPY2E018
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E019,
    originError: errorCodeCHKPY2E019
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E020,
    originError: errorCodeCHKPY2E020
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E021,
    originError: errorCodeCHKPY2E021
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E022,
    originError: errorCodeCHKPY2E022
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E9998,
    originError: errorCodeCHKPY2E9998
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E9999,
    originError: errorCodeCHKPY2E9999
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E500,
    originError: errorCodeCHKPY2E500
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E000,
    originError: errorCodeCHKPY2E000
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E002,
    originError: errorCodeCHKPY2E002
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E004,
    originError: errorCodeCHKPY2E004
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E015,
    originError: errorCodeCHKPY2E015
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E023,
    originError: errorCodeCHKPY2E023
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E024,
    originError: errorCodeCHKPY2E024
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E025,
    originError: errorCodeCHKPY2E025
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E026,
    originError: errorCodeCHKPY2E026
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E028,
    originError: errorCodeCHKPY2E028
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage26,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E029,
    originError: errorCodeCHKPY2E029
  },
  {
    title: errorTitleGiftCardSinSaldo,
    message: errorMessage30,
    type: Type.INFO,
    cta: ECta.SELECCIONA,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E001,
    originError: errorCodeCHKPY2E001
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage31,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E008,
    originError: errorCodeCHKPY2E008
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage31,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY2E010,
    originError: errorCodeCHKPY2E010
  },
  {
    title: errorTitleGiftCardNoValida,
    message: errorMessage16,
    type: Type.INFO,
    cta: ECta.SELECCIONA,
    contentAssets: contentAssestPaymentsPayCardExpired,
    errorCode: errorCodeCHKPY2E016,
    originError: errorCodeCHKPY2E016
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage20,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsPayCardExpired,
    errorCode: errorCodeCHKPY2E030,
    originError: errorCodeCHKPY2E030
  },
  {
    title: errorTitleRutIncorrecto,
    message: errorMessage21,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsPayCardExpired,
    errorCode: errorCodeCHKPY2E027,
    originError: errorCodeCHKPY2E027
  },
  {
    title: errorTitleProblemasGiftCard,
    message: errorMessage22,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsPayCardExpired,
    errorCode: errorCodeCHKPY2E031,
    originError: errorCodeCHKPY2E031
  },
  {
    title: errorTitleClaveIncorrecta,
    message: errorMessage32,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsPayCardExpired,
    errorCode: errorCodeCHKPY2E014,
    originError: errorCodeCHKPY2E014
  },
  {
    title: errorTitleProductosNoPagoGiftCard,
    message: errorMessage45,
    type: Type.INFO,
    cta: ECta.SELECCIONA,
    contentAssets: contentAssestPaymentsPayLimit,
    errorCode: errorCodeCHKPY2E017,
    originError: errorCodeCHKPY2E017
  },
  {
    title: errorTitleNoAgregarGiftCard,
    message: errorMessage32,
    type: Type.INFO,
    cta: ECta.SELECCIONA,
    contentAssets: contentAssestPaymentsPayLimit,
    errorCode: errorCodeCHKPY2E433,
    originError: errorCodeCHKPY2E433
  },
  //tcom errors
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage04,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY260010,
    originError: errorCodeCHKPY260010
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage04,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY260006,
    originError: errorCodeCHKPY260006
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage04,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY260009,
    originError: errorCodeCHKPY260009
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage04,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY60091,
    originError: errorCodeCHKPY60091
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage04,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY60095,
    originError: errorCodeCHKPY60095
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage04,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY60095,
    originError: errorCodeCHKPY60095
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage04,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY60095,
    originError: errorCodeCHKPY60095
  },
  {
    title: errorTitleExidisteMontoMaximo,
    message: errorMessage42,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY260098,
    originError: errorCodeCHKPY260098
  },
  {
    title: errorTitleLimiteCompras,
    message: errorMessage44,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY260099,
    originError: errorCodeCHKPY260099
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage04,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY60096,
    originError: errorCodeCHKPY60096
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage04,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY60099,
    originError: errorCodeCHKPY60099
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage04,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY260500,
    originError: errorCodeCHKPY260500
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage04,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY60092,
    originError: errorCodeCHKPY60092
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage04,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY60093,
    originError: errorCodeCHKPY60093
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage04,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY60094,
    originError: errorCodeCHKPY60094
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage04,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY260100,
    originError: errorCodeCHKPY260100
  },
  {
    title: errorTitleSuperasteLimite,
    message: errorMessage43,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY260011,
    originError: errorCodeCHKPY260011
  },
  {
    title: errorTitleExidisteMontoMaximo,
    message: errorMessage42,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY260003,
    originError: errorCodeCHKPY260003
  },
  {
    title: errorTitleTarjetaExpiro,
    message: errorMessage13,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY260008,
    originError: errorCodeCHKPY260008
  },
  {
    title: errorTitleTarjetaExpiro,
    message: errorMessage13,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY210008,
    originError: errorCodeCHKPY210008
  },
  {
    title: errorTitleTarjetaBloqueada,
    message: errorMessage25,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY260007,
    originError: errorCodeCHKPY260007
  },
  {
    title: errorTitleTarjetaBloqueada,
    message: errorMessage13,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY210007,
    originError: errorCodeCHKPY210007
  },
  {
    title: errorTitleOcurrioErrorConexion,
    message: errorMessage15,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsDog,
    errorCode: errorCodeCHKPY260002,
    originError: errorCodeCHKPY260002
  },
  {
    title: errorTitleTarjetaInvalida,
    message: errorMessage14,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsPayCardExpired,
    errorCode: errorCodeCHKPY260001,
    originError: errorCodeCHKPY260001
  },
  {
    title: errorTitleRevisaDatosIngresados,
    message: errorMessage27,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsPayCardExpired,
    errorCode: errorCodeCHKPY260004,
    originError: errorCodeCHKPY260004
  },
  {
    title: errorTitleRevisaDatosIngresados,
    message: errorMessage27,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsPayCardExpired,
    errorCode: errorCodeCHKPY260005,
    originError: errorCodeCHKPY260005
  },
  //webpay errors
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage10,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY210009,
    originError: errorCodeCHKPY210009
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage10,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY210010,
    originError: errorCodeCHKPY210010
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage10,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY210006,
    originError: errorCodeCHKPY210006
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage10,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY210095,
    originError: errorCodeCHKPY210095
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage10,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY210096,
    originError: errorCodeCHKPY210096
  },
  {
    title: errorTitleExidisteMonto,
    message: errorMessage11,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY210097,
    originError: errorCodeCHKPY210097
  },
  {
    title: errorTitleExidisteMontoMaximo,
    message: errorMessage42,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY210098,
    originError: errorCodeCHKPY210098
  },
  {
    title: errorTitleLimiteCompras,
    message: errorMessage44,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY210099,
    originError: errorCodeCHKPY210099
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage10,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY210500,
    originError: errorCodeCHKPY210500
  },
  {
    title: errorTitleSuperasteLimite,
    message: errorMessage10,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY210011,
    originError: errorCodeCHKPY210011
  },
  {
    title: errorTitleExidisteMontoMaximo,
    message: errorMessage42,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY210003,
    originError: errorCodeCHKPY210003
  },
  {
    title: errorTitleErrorConexion,
    message: errorMessage15,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsDog,
    errorCode: errorCodeCHKPY210002,
    originError: errorCodeCHKPY210002
  },
  {
    title: errorTitleTarjetaInvalida,
    message: errorMessage14,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsPayCardExpired,
    errorCode: errorCodeCHKPY210001,
    originError: errorCodeCHKPY210001
  },
  {
    title: errorTitleRevisaDatosIngresados,
    message: errorMessage27,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsPayCardExpired,
    errorCode: errorCodeCHKPY210004,
    originError: errorCodeCHKPY210004
  },
  {
    title: errorTitleRevisaDatosIngresados,
    message: errorMessage27,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsPayCardExpired,
    errorCode: errorCodeCHKPY210005,
    originError: errorCodeCHKPY210005
  },
  //spreedly errors
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage06,
    type: Type.INFO,
    cta: ECta.REINTENTAR,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKSPD000,
    originError: '400-0'
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage06,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKSPD001,
    originError: '400-1'
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage06,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKSPD002,
    originError: '400-2'
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage06,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKSPD003,
    originError: '400-4'
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage06,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKSPD004,
    originError: '500-0'
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage06,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKSPD005,
    originError: '500-1'
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage06,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKSPD006,
    originError: '500-2'
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage06,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKSPD007,
    originError: '500-5'
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage06,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKSPD008,
    originError: '422'
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage06,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKSPD009,
    originError: '400-3'
  },
  //giv errors
  {
    title: errorTitleProductoAgtado,
    message: errorMessage40,
    type: Type.REDIRECT,
    redirectUrl: URL_ROUTES.SHIPPING,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKDM0001,
    originError: 'OUT_OF_STOCK'
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage03,
    type: Type.REDIRECT,
    redirectUrl: URL_ROUTES.SHIPPING,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKDM0002,
    originError: 'DUPLICATE_ITEMS'
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage03,
    type: Type.REDIRECT,
    redirectUrl: URL_ROUTES.SHIPPING,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKDM0003,
    originError: 'DUPLICATE_ORDER_LINE_ID'
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage03,
    type: Type.REDIRECT,
    redirectUrl: URL_ROUTES.SHIPPING,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKDM0004,
    originError: 'DUPLICATE_REFERENCE_ID'
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage03,
    type: Type.REDIRECT,
    redirectUrl: URL_ROUTES.SHIPPING,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKDM0005,
    originError: 'DUPLICATE_ORDER_ID'
  },
  {
    title: errorTitleEntrega,
    message: errorMessage41,
    type: Type.REDIRECT,
    redirectUrl: URL_ROUTES.SHIPPING,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKDM0006,
    originError: 'DELIVERY_HOME_SD_NOT_AVAILABLE'
  },
  {
    title: errorTitleStockInsuficiente,
    message: errorMessage23,
    type: Type.REDIRECT,
    redirectUrl: URL_ROUTES.SHIPPING,
    cta: ECta.MODIFICAR_PEDIDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKDM0007,
    originError: 'INSUFFICIENT_QUANTITY'
  },
  //cybersource
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30101,
    originError: errorCodeCHKPY30101
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30102,
    originError: errorCodeCHKPY30102
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30104,
    originError: errorCodeCHKPY30104
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30110,
    originError: errorCodeCHKPY30110
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30150,
    originError: errorCodeCHKPY30150
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30151,
    originError: errorCodeCHKPY30151
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30152,
    originError: errorCodeCHKPY30152
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30154,
    originError: errorCodeCHKPY30154
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY301200,
    originError: errorCodeCHKPY301200
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30201,
    originError: errorCodeCHKPY30201
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30202,
    originError: errorCodeCHKPY30202
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30203,
    originError: errorCodeCHKPY30203
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30203,
    originError: errorCodeCHKPY30203
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30205,
    originError: errorCodeCHKPY30205
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY301207,
    originError: errorCodeCHKPY301207
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30208,
    originError: errorCodeCHKPY30208
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30209,
    originError: errorCodeCHKPY30209
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30210,
    originError: errorCodeCHKPY30210
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30211,
    originError: errorCodeCHKPY30211
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30220,
    originError: errorCodeCHKPY30220
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30221,
    originError: errorCodeCHKPY30221
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30222,
    originError: errorCodeCHKPY30222
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30230,
    originError: errorCodeCHKPY30230
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30231,
    originError: errorCodeCHKPY30231
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30232,
    originError: errorCodeCHKPY30232
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30233,
    originError: errorCodeCHKPY30233
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30234,
    originError: errorCodeCHKPY30234
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30235,
    originError: errorCodeCHKPY30235
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30236,
    originError: errorCodeCHKPY30236
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30237,
    originError: errorCodeCHKPY30237
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30238,
    originError: errorCodeCHKPY30238
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30239,
    originError: errorCodeCHKPY30239
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30240,
    originError: errorCodeCHKPY30240
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30241,
    originError: errorCodeCHKPY30241
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30242,
    originError: errorCodeCHKPY30242
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30243,
    originError: errorCodeCHKPY30243
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30246,
    originError: errorCodeCHKPY30246
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30247,
    originError: errorCodeCHKPY30247
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30248,
    originError: errorCodeCHKPY30248
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30250,
    originError: errorCodeCHKPY30250
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30251,
    originError: errorCodeCHKPY30251
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30254,
    originError: errorCodeCHKPY30254
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30268,
    originError: errorCodeCHKPY30268
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30400,
    originError: errorCodeCHKPY30400
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30450,
    originError: errorCodeCHKPY30450
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30451,
    originError: errorCodeCHKPY30451
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30452,
    originError: errorCodeCHKPY30452
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30453,
    originError: errorCodeCHKPY30453
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30454,
    originError: errorCodeCHKPY30454
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30455,
    originError: errorCodeCHKPY30455
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30456,
    originError: errorCodeCHKPY30456
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30457,
    originError: errorCodeCHKPY30457
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30458,
    originError: errorCodeCHKPY30458
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30459,
    originError: errorCodeCHKPY30459
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30460,
    originError: errorCodeCHKPY30460
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30461,
    originError: errorCodeCHKPY30461
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30475,
    originError: errorCodeCHKPY30475
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30476,
    originError: errorCodeCHKPY30476
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30478,
    originError: errorCodeCHKPY30478
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30480,
    originError: errorCodeCHKPY30480
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30481,
    originError: errorCodeCHKPY30481
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30490,
    originError: errorCodeCHKPY30490
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30491,
    originError: errorCodeCHKPY30491
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30520,
    originError: errorCodeCHKPY30520
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30700,
    originError: errorCodeCHKPY30700
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30701,
    originError: errorCodeCHKPY30701
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30702,
    originError: errorCodeCHKPY30702
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30703,
    originError: errorCodeCHKPY30703
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY60092,
    originError: errorCodeCHKPY60092
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY60093,
    originError: errorCodeCHKPY60093
  },
  {
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage07,
    type: Type.INFO,
    cta: ECta.ENTIENDO,
    contentAssets: contentAssestPaymentsGiftcard,
    errorCode: errorCodeCHKPY30204,
    originError: errorCodeCHKPY30204
  },
  // personal information errors
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage38,
    cta: ECta.ENTIENDO,
    type: Type.INFO,
    errorCode: errorCodeCHKRECST001,
    originError: errorCodeCHKRECST001
  },
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage38,
    cta: ECta.ENTIENDO,
    type: Type.INFO,
    errorCode: errorCodeCHKRECST002,
    originError: errorCodeCHKRECST002
  },
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage38,
    cta: ECta.ENTIENDO,
    type: Type.INFO,
    errorCode: errorCodeCHKRECST005,
    originError: errorCodeCHKRECST005
  },
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage39,
    cta: ECta.IR_A_DATOS,
    redirectUrl: URL_ROUTES.PERSONAL_DETAILS,
    type: Type.REDIRECT,
    errorCode: errorCodeCHKGSCST001,
    originError: errorCodeCHKGSCST001
  },
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage39,
    cta: ECta.IR_A_DATOS,
    redirectUrl: URL_ROUTES.PERSONAL_DETAILS,
    type: Type.REDIRECT,
    errorCode: errorCodeCHKGSCST002,
    originError: errorCodeCHKGSCST002
  },
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage39,
    cta: ECta.IR_A_DATOS,
    redirectUrl: URL_ROUTES.PERSONAL_DETAILS,
    type: Type.REDIRECT,
    errorCode: errorCodeCHKGSCST005,
    originError: errorCodeCHKGSCST005
  },
  // invalid rut or email errors
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage33,
    cta: ECta.IR_AL_WSP_PARIS,
    type: Type.INFO,
    errorCode: errorCodeCHKRECST003,
    originError: errorCodeCHKRECST003
  },
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage33,
    cta: ECta.IR_AL_WSP_PARIS,
    type: Type.INFO,
    errorCode: errorCodeCHKRECST004,
    originError: errorCodeCHKRECST004
  },
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage34,
    cta: ECta.IR_A_DATOS,
    redirectUrl: URL_ROUTES.PERSONAL_DETAILS,
    type: Type.REDIRECT,
    errorCode: errorCodeCHKGSCST003,
    originError: errorCodeCHKGSCST003
  },
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage34,
    cta: ECta.IR_A_DATOS,
    redirectUrl: URL_ROUTES.PERSONAL_DETAILS,
    type: Type.REDIRECT,
    errorCode: errorCodeCHKGSCST004,
    originError: errorCodeCHKGSCST004
  },
  // default rut errors
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage36,
    cta: ECta.ENTIENDO,
    type: Type.INFO,
    errorCode: errorCodeCHKRERUT001,
    originError: errorCodeCHKRERUT001
  },
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage34,
    cta: ECta.IR_A_DATOS,
    redirectUrl: URL_ROUTES.PERSONAL_DETAILS,
    type: Type.REDIRECT,
    errorCode: errorCodeCHKGSRUT001,
    originError: errorCodeCHKGSRUT001
  },
  //addresses errors
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage35,
    cta: ECta.IR_A_ENTREGA,
    redirectUrl: URL_ROUTES.SHIPPING,
    type: Type.REDIRECT,
    errorCode: errorCodeCHKREADR001,
    originError: errorCodeCHKREADR001
  },
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage35,
    cta: ECta.IR_A_ENTREGA,
    redirectUrl: URL_ROUTES.SHIPPING,
    type: Type.REDIRECT,
    errorCode: errorCodeCHKREADR002,
    originError: errorCodeCHKREADR002
  },
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage35,
    cta: ECta.IR_A_ENTREGA,
    redirectUrl: URL_ROUTES.SHIPPING,
    type: Type.REDIRECT,
    errorCode: errorCodeCHKREADR003,
    originError: errorCodeCHKREADR003
  },
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage35,
    cta: ECta.IR_A_ENTREGA,
    redirectUrl: URL_ROUTES.SHIPPING,
    type: Type.REDIRECT,
    errorCode: errorCodeCHKGSADR001,
    originError: errorCodeCHKGSADR001
  },
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage35,
    cta: ECta.IR_A_ENTREGA,
    redirectUrl: URL_ROUTES.SHIPPING,
    type: Type.REDIRECT,
    errorCode: errorCodeCHKGSADR002,
    originError: errorCodeCHKGSADR002
  },
  {
    contentAssets: contentAssestPaymentsPayCardExpired,
    title: errorTitleNoPudimosProcesarPago,
    message: errorMessage35,
    cta: ECta.IR_A_ENTREGA,
    redirectUrl: URL_ROUTES.SHIPPING,
    type: Type.REDIRECT,
    errorCode: errorCodeCHKGSADR003,
    originError: errorCodeCHKGSADR003
  },
  // general and discrepancy errors
  {
    contentAssets: contentAssestPaymentsPayCardBlocked,
    title: errorTitleErrorDePago,
    message: errorMessage37,
    cta: ECta.REINTENTAR,
    type: Type.REDIRECT,
    redirectUrl: URL_ROUTES.SHIPPING,
    errorCode: errorCodeCHKREAMT001,
    originError: errorCodeCHKREAMT001
  },
  {
    contentAssets: contentAssestPaymentsPayCardBlocked,
    title: errorTitleErrorDePago,
    message: errorMessage37,
    cta: ECta.REINTENTAR,
    type: Type.REDIRECT,
    redirectUrl: URL_ROUTES.SHIPPING,
    errorCode: errorCodeCHKGSAMT001,
    originError: errorCodeCHKGSAMT001
  },
  {
    contentAssets: contentAssestPaymentsDefault,
    title: errorTitleOcurrioErrorConexion,
    message: errorMessage15,
    cta: ECta.ENTIENDO,
    type: Type.REDIRECT,
    redirectUrl: URL_ROUTES.HOME,
    errorCode: errorCodeCHKPY210090,
    originError: ErrorTypeBilling.DEFAULT
  },
  {
    contentAssets: contentAssestPaymentsPay,
    title: errorTitleCuponExpirado,
    message: errorMessage47,
    type: Type.INFO,
    cta: ECta.REINTENTAR,
    errorCode: errorCodeCHKCOUPON001,
    originError: errorCodeCHKCOUPON001
  }
];
